import { useCallback, useEffect, useState } from 'react'
import { completeEnrollmentSignupSession } from '../actions'
import { StepNames } from '../types'
import { useDispatch } from './useDispatch'
import { useFindAutoClaimPrinter } from './useFindAutoClaimPrinter'

type UseFlipEnrollActionsReturn = {
  tosMustBeAccepted: boolean
  showTermsModal: boolean
  setTosAccepted: (value: boolean) => void
  handleOpenTermsModal: () => void
  handleCloseTermsModal: () => void
  verifyAndEnroll: () => void
}

export const useFlipEnrollActions = (): UseFlipEnrollActionsReturn => {
  const dispatch = useDispatch()
  const { findAutoClaimPrinter } = useFindAutoClaimPrinter(
    StepNames.FTM_ENROLL_STEP
  )
  const [tosAccepted, setTosAccepted] = useState(false)
  const [tosMustBeAccepted, setTOSMustBeAccepted] = useState(false)
  const [showTermsModal, setShowTermsModal] = useState(false)

  useEffect(() => {
    if (tosAccepted) {
      setTOSMustBeAccepted(false)
    }
  }, [tosAccepted])

  const onEnroll = useCallback(async () => {
    await findAutoClaimPrinter()
    await dispatch(completeEnrollmentSignupSession())
  }, [dispatch, findAutoClaimPrinter])

  const verifyAndEnroll = useCallback(() => {
    if (!tosAccepted) {
      setTOSMustBeAccepted(true)
      return
    }

    if ('scrollRestoration' in globalThis.history) {
      globalThis.history.scrollRestoration = 'auto'
    }

    localStorage.removeItem('hide_modals')
    onEnroll()
  }, [onEnroll, setTOSMustBeAccepted, tosAccepted])

  const handleOpenTermsModal = useCallback(() => {
    setShowTermsModal(true)
  }, [])

  const handleCloseTermsModal = useCallback(() => {
    setShowTermsModal(false)
  }, [])

  return {
    tosMustBeAccepted,
    showTermsModal,
    setTosAccepted,
    handleOpenTermsModal,
    handleCloseTermsModal,
    verifyAndEnroll
  }
}
